import clsx from 'clsx'
import type { ReactElement } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { TextareaInput } from '~/components/Form'
import { fieldset, fieldsetOpen } from '~/components/Form/Form.css'
import {
  SHORTLIST_PLACEHOLDER,
  shortlistCommentKey
} from '../forms/shortlistComments'
import {
  userComment,
  userCommentInput,
  userCommentName,
  userComments,
  userCommentsTitle
} from './ShortlistUserCommentsField.css'

type ShortlistUserCommentsFieldProps = {
  applicants: { id: number; firstname: string; lastname: string }[]
}

export const ShortlistUserCommentsField = ({
  applicants
}: ShortlistUserCommentsFieldProps): ReactElement | null => {
  const { register, control } = useFormContext()
  const message = useWatch({ control, name: 'message' })

  if (typeof message !== 'string' || !message.includes(SHORTLIST_PLACEHOLDER)) {
    return null
  }

  return (
    <div className={clsx(fieldset, fieldsetOpen, userComments)}>
      <div className={userCommentsTitle}>
        Commentaires affichés au contact sur la shortlist
      </div>
      {applicants.map((applicant) => (
        <div key={applicant.id} className={userComment}>
          <span className={userCommentName}>
            {applicant.firstname} {applicant.lastname}
          </span>
          <TextareaInput
            name={`shortlistComments.${shortlistCommentKey(applicant.id)}`}
            placeholder="Commentaire pour le contact (facultatif)"
            className={userCommentInput}
            rows={1}
            register={register}
            control={control}
          />
        </div>
      ))}
    </div>
  )
}
